import { BaasicInput } from 'core/components';
import React from 'react';
import { PropTypes } from 'mobx-react';

const SearchTypeSwitch = (props) => {
	const { store } = props;
	const { searchType, switchItems } = store;

	return (
		<div className="input--switch">
			{switchItems.map((s) => (
				<BaasicInput
					checked={searchType === s.name}
					id={s.id}
					key={s.id}
					label={s.label}
					labelClassName={searchType === s.name ? 'activeType' : ''}
					name={s.name}
					onChange={() => s.onChange(s.name)}
					type="radio"
					value={s.name}
					wrapperClassName="input--switch__wrapper"
				/>
			))}
		</div>
	);
};

SearchTypeSwitch.propTypes = {
    store: PropTypes.object,
};

export default SearchTypeSwitch;
